import styled from "styled-components";

export const StyledRatings = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
`;

export const StyledRatingsContent = styled.div`
    padding: 40px;
`;
